<template>
    <Head title="Meta Settings"/>
    <div class="w-full min-h-screen flex flex-col bg-gray-100 dark:bg-gray-500">
        <div class="bg-white dark:bg-gray-700 flex flex-col">
            <div class="flex flex-col flex-grow justify-center">
                <div class="max-w-7xl flex flex-grow flex-row pt-4 px-4 sm:pt-6 lg:px-8 items-center">
                    <div class="cursor-pointer" @click="back">
                        <ArrowLeftIcon class="h-7 w-7 mr-4 sm:h-8 sm:w-8 text-gray-500 dark:text-gray-100"/>
                    </div>
                    <div class="flex flex-col">
                        <h1 class="text-3xl font-extrabold tracking-tight text-gray-900 dark:text-gray-100">Login Approvals</h1>
                        <div class="py-2 whitespace-nowrap text-sm text-red-500">
                            Approve / Deny Login Approvals
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex flex-col m-8 dark:text-white">
            <div class="mb-4 flex flex-row justify-between items-center">
                <h2 class="font-bold">Pending</h2>
            </div>
            <div class="flex flex-col">
                <approval-log v-for="log in pending" :log="log"
                    @rejected="updateRequests(log.visitorId, false)"
                    @approved="updateRequests(log.visitorId, true)"/>
                <span class="text-center rounded-lg shadow bg-gray-300 dark:bg-gray-600 text-gray-900 dark:text-gray-200 p-2"
                      v-if="!pending.length">
                    No Logins To Approve
                </span>
            </div>
        </div>
        <div class="flex flex-col m-8 dark:text-white">
            <div class="mb-4 flex flex-row justify-between items-center">
                <h2 class="font-bold">Approved</h2>
            </div>
            <div class="flex flex-col">
                <approval-log v-for="log in approved" :log="log"
                    @rejected="updateRequests(log.visitorId, false)"
                    @approved="updateRequests(log.visitorId, true)"/>
                <span class="text-center rounded-lg shadow bg-gray-300 dark:bg-gray-600 text-gray-900 dark:text-gray-200 p-2"
                      v-if="!approved.length">
                    No Logins Approved So far
                </span>
            </div>
        </div>
        <div class="flex flex-col m-8 dark:text-white">
            <div class="mb-4 flex flex-row justify-between items-center">
                <h2 class="font-bold">Rejected</h2>
            </div>
            <div class="flex flex-col">
                <approval-log v-for="log in rejected" :log="log"
                    @rejected="updateRequests(log.visitorId, false)"
                    @approved="updateRequests(log.visitorId, true)"/>
                <span class="text-center rounded-lg shadow bg-gray-300 dark:bg-gray-600 text-gray-900 dark:text-gray-200 p-2"
                      v-if="!rejected.length">
                    No Logins Rejected So Far
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import Layout from '@/Shared/Layout'
import {Inertia} from "@inertiajs/inertia";
import { Head } from "@inertiajs/inertia-vue3";
import { ArrowLeftIcon } from "@heroicons/vue/solid";
import ApprovalLog from "@/Pages/Settings/Components/ApprovalLog";

export default {
    layout: Layout,
    props: {
        approvals: Array,
    },
    components: {
        ApprovalLog,
        Head,
        ArrowLeftIcon,
    },
    data() {
        return {
            busy: false,
        }
    },
    computed: {
        pending() {
            return this.approvals.filter(a => a.created_at === a.updated_at)
        },
        approved() {
            return this.approvals.filter(a => a.created_at !== a.updated_at && a.allowed === true)
        },
        rejected() {
            return this.approvals.filter(a => a.created_at !== a.updated_at && a.allowed === false)
        }
    },
    methods: {
        async updateRequests(visitor, approve) {
            this.busy = true;
            const response = await axios.patch(
                this.$route('settings.login_approvals.' + (approve ? 'approve' : 'deny'), {
                    visitor
                })
            )
            if (response.data && response.data.message) {
                this.reloadPage();
            }
            this.busy = false;
        },
        reloadPage() {
            Inertia.reload({
                preserveScroll: true
            })
        }
    }
}
</script>
